<template>
  <el-dialog title="课程调整申请" :visible.sync="dialogVisible" width="460px" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
    <div v-loading="loading" class="diloag-course-change">
      <h6>选择课程异动申请类型</h6>
      <el-radio-group v-model="radioTarget">
        <template v-for="item in radioList">
          <el-radio :key="item.id" :label="item.id" class="checkbox-inline">{{ item.title }}</el-radio>
        </template>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :disabled="!radioTarget" @click="SubmitNext">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue'
import API from '@/api'
import Store from '@/store'

const props = defineProps({
  visible: {
    type: Boolean,
    default: () => false
  }
})

const radioTarget = ref(null)
const radioList = ref([])
const loading = ref(false)

const emit = defineEmits(['handleClose', 'SubmitNext'])

const dialogVisible = computed(() => {
  return props.visible
})
const mobile = ref(null)
onMounted(() => {
  loading.value = true
  API.MBAApplyCourseChangePrepare()
    .then(res => {
      const { applyTypes } = res.data

      radioList.value = applyTypes
      mobile.value = res.data.mobile
      Store.commit('common/SET_COURSE_APPLY_TYPES', applyTypes)
      loading.value = false
    })
    .catch(_ => {
      loading.value = false
    })
})

const handleClose = () => {
  emit('update:visible', false)
}

const SubmitNext = () => {
  emit('success', radioTarget.value, mobile.value)
  setTimeout(() => {
    emit('update:visible', false)
  }, 500)
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog__header) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
}
:deep(.el-dialog__footer) {
  border-top: 1px solid rgba(0, 0, 0, 0.09);
}
:deep(.el-dialog__body) {
  padding-top: 16px;
}
h6 {
  font-size: 14px;
  color: #666666;
  margin-bottom: 2px !important;
}
:deep(.el-radio) {
  color: #888;
}
</style>
